var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYouTube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33_2439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2824 9.27836C35.0789 8.51248 34.6778 7.81349 34.1192 7.25134C33.5607 6.6892 32.8643 6.28361 32.0997 6.07518C29.2852 5.31836 18.0352 5.31836 18.0352 5.31836C18.0352 5.31836 6.78516 5.31836 3.97061 6.07518C3.20605 6.28361 2.50964 6.6892 1.95109 7.25134C1.39253 7.81349 0.991415 8.51248 0.787884 9.27836C0.0351563 12.1052 0.0351562 18.0002 0.0351562 18.0002C0.0351562 18.0002 0.0351563 23.8952 0.787884 26.722C0.991415 27.4879 1.39253 28.1869 1.95109 28.749C2.50964 29.3112 3.20605 29.7167 3.97061 29.9252C6.78516 30.682 18.0352 30.682 18.0352 30.682C18.0352 30.682 29.2852 30.682 32.0997 29.9252C32.8643 29.7167 33.5607 29.3112 34.1192 28.749C34.6778 28.1869 35.0789 27.4879 35.2824 26.722C36.0352 23.8952 36.0352 18.0002 36.0352 18.0002C36.0352 18.0002 36.0352 12.1052 35.2824 9.27836Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3555 23.3534V12.6475L23.7646 18.0004L14.3555 23.3534Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33_2439"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTube);
export default __webpack_public_path__ + "static/media/YouTube.b44a6bb90148c7c6975051ec5b167ae8.svg";
export { ForwardRef as ReactComponent };